import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzMenuModule } from "ng-zorro-antd/menu";

@Component({
	selector: "app-layout-auth",
	imports: [
		CommonModule,
		RouterOutlet,
		NzIconModule,
		NzLayoutModule,
		NzMenuModule,
	],
	template: `<nz-layout class="app-layout ">
      <nz-content>
          <router-outlet></router-outlet>
      </nz-content>
  </nz-layout>
  `,
	styles: [
		`:host {
    display: flex;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .app-layout {
    height: 100vh;
  }

  nz-content {
    margin: 24px;
  }

  .inner-content {
    padding: 24px;
    background: #fff;
  }
  `,
	],
})
export class LayoutAuthComponent {
	isCollapsed = false;
}
